import React from "react";
import { Stars, CatTag, SectionTitle } from "./helpers";

export default function Modal360({ proveedor: p, onClose, onEditar }) {
  const contactosList = p.contactos?.length > 0
    ? p.contactos
    : (p.contacto ? [{ nombre: p.contacto, cargo: "", zona: "", telefono: p.telefono || "", email: p.email || "" }] : []);

  const categoriasList = p.categorias?.length > 0
    ? p.categorias
    : (p.materiales ? p.materiales.split(",").map(m => m.trim()).filter(Boolean) : []);

  return (
    <div className="modal-overlay" style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div className="modal-content" style={{ background: "#fff", borderRadius: 16, maxWidth: 640, width: "100%", maxHeight: "88vh", overflowY: "auto" }}>

        <div style={{ padding: "20px 24px 16px", borderBottom: "1px solid #f1f5f9" }}>
          <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 10 }}>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 2 }}>
                <h2 style={{ fontSize: 20, fontWeight: 700, color: "#1e293b", margin: 0 }}>
                  {p.nombreComercial || p.nombre}
                </h2>
                {p.creditoDias && (
                  <span style={{ fontSize: 10, fontWeight: 700, padding: "2px 7px", borderRadius: 5, background: "#E1F5EE", color: "#0F6E56" }}>
                    💳 Crédito {p.creditoDias}d
                  </span>
                )}
              </div>
              {p.nombreComercial && p.nombre && (
                <div style={{ fontSize: 12, color: "#64748b", marginBottom: 4, fontStyle: "italic" }}>
                  Razón social: {p.nombre}
                </div>
              )}
              <div style={{ fontSize: 12, color: "#64748b", marginBottom: 6 }}>
                {[p.ruc && `RUC ${p.ruc}`, p.ciudad, p.direccion].filter(Boolean).join(" · ")}
                {p.website && (
                  <a href={p.website.startsWith("http") ? p.website : `https://${p.website}`}
                    target="_blank" rel="noreferrer"
                    style={{ marginLeft: 8, color: "#2563eb", textDecoration: "none" }}>
                    🌐 {p.website}
                  </a>
                )}
              </div>
              <Stars n={p.calificacion} />
            </div>
            <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
              <button onClick={onEditar} style={{ fontSize: 11, fontWeight: 600, padding: "6px 12px", borderRadius: 8, background: "#dbeafe", color: "#1d4ed8", border: "none", cursor: "pointer" }}>
                ✏ Editar
              </button>
              <button onClick={onClose} style={{ fontSize: 11, padding: "6px 12px", borderRadius: 8, background: "#f1f5f9", color: "#64748b", border: "none", cursor: "pointer" }}>
                ✕
              </button>
            </div>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 0, borderBottom: "1px solid #f1f5f9" }}>
          {[
            { label: "Plazo entrega",  val: p.plazoDias   ? `${p.plazoDias}d`   : "—" },
            { label: "Crédito",        val: p.creditoDias ? `${p.creditoDias}d` : "—" },
            { label: "Calificación",   val: <Stars n={p.calificacion} /> },
          ].map(k => (
            <div key={k.label} style={{ padding: "12px 20px", borderRight: "1px solid #f1f5f9", textAlign: "center" }}>
              <div style={{ fontSize: 10, color: "#94a3b8", marginBottom: 4 }}>{k.label}</div>
              <div style={{ fontSize: 16, fontWeight: 700, color: "#1e293b" }}>{k.val}</div>
            </div>
          ))}
        </div>

        {categoriasList.length > 0 && (
          <div style={{ padding: "14px 24px", borderBottom: "1px solid #f1f5f9" }}>
            <SectionTitle>Categorías de materiales</SectionTitle>
            <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginTop: 8 }}>
              {categoriasList.map(c => <CatTag key={c} label={c} />)}
            </div>
          </div>
        )}

        <div style={{ padding: "14px 24px", borderBottom: "1px solid #f1f5f9" }}>
          <SectionTitle>Contactos / Asesores</SectionTitle>
          {contactosList.length === 0 ? (
            <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 8 }}>Sin contactos registrados.</div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 8 }}>
              {contactosList.map((c, i) => (
                <div key={i} style={{ background: "#f8fafc", borderRadius: 10, padding: "10px 14px", display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: "#1e293b" }}>{c.nombre}</span>
                      {c.cargo && <span style={{ fontSize: 11, color: "#64748b" }}>{c.cargo}</span>}
                      {c.zona && (
                        <span style={{ fontSize: 10, fontWeight: 700, padding: "2px 7px", borderRadius: 4, background: "#FAEEDA", color: "#854F0B" }}>
                          📍 {c.zona}
                        </span>
                      )}
                    </div>
                    {c.email && <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 3 }}>{c.email}</div>}
                  </div>
                  {c.telefono && (
                    <button onClick={() => window.open(`https://wa.me/51${c.telefono.replace(/\D/g,"")}`, "_blank")}
                      style={{ fontSize: 11, padding: "5px 10px", borderRadius: 6, background: "#DCF8C6", color: "#128C7E", border: "none", cursor: "pointer", fontWeight: 600, whiteSpace: "nowrap" }}>
                      📱 {c.telefono}
                    </button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        {p.notas && (
          <div style={{ padding: "14px 24px" }}>
            <SectionTitle>Notas</SectionTitle>
            <p style={{ fontSize: 12, color: "#475569", lineHeight: 1.7, margin: "8px 0 0", background: "#f8fafc", padding: "10px 14px", borderRadius: 8 }}>
              {p.notas}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
